import get from 'lodash/get';

function beforeRequest(actionContext, { options }) {
	actionContext.dispatch('RETRIEVE_DOCUMENT_START', options?.documentEvent);
}

function onSuccess(actionContext, { response }) {
	actionContext.dispatch('RETRIEVE_DOCUMENT_FINISH', [null, response.data]);
}

function onFailed(actionContext, { error }) {
	actionContext.dispatch('RETRIEVE_DOCUMENT_FINISH', [error, null]);
}

export default config => ({
	serviceName: 'retrieveDocument',
	authenticate: true,
	config: {
		method: 'GET',
		url: get(config, 'endpoints.prompt.document.retrieve'),
	},
	beforeRequest,
	onSuccess,
	onFailed,
	onError: onFailed,
	onTimeout: onFailed,
	onFatal: onFailed,
});
